import CloseIcon from '../../../assets/icons/close.svg?react';
import { useState } from 'react';
import Selector from '../../../components/Selector';
import { useCreateReportRequest } from '../../../hooks/queries/reportQueries';
import { useAuth } from '../../../hooks/useAuth';
const ReportAppendModal = ({ onClose, onSuccess }) => {
  const [isPending, setIsPending] = useState(false);
  const [fromData, setFromData] = useState({
    reportName: '',
    reportTemplate: null,
  });
  const createReportRequest = useCreateReportRequest();
  const { user } = useAuth();
  const handleChangeSelector = (selectedItem) => {
    setFromData({ ...fromData, reportTemplate: selectedItem });
  };
  const transformReportTemplateData = (data) => {
    if (!data?.Items) return [];
    return data.Items.map((item) => ({
      id: item.ReportTemplateInfoSysId,
      label: item.TemplateName + ' (' + item.Version + ')',
      data: item,
    }));
  };
  const buildApiParams = (searchQuery) => {
    return {
      TemplateName: searchQuery,
    };
  };
  const getQueryKeys = (searchQuery) => {
    return ['reportTemplate', 'selector', searchQuery];
  };
  const handleChangeInput = (e) => {
    setFromData({ ...fromData, [e.target.name]: e.target.value });
  };
  const handleCreateReportRequest = async () => {
    try {
      setIsPending(true);
      await createReportRequest.mutateAsync({
        fileTitle: fromData.reportName,
        selectedTemplateId: fromData.reportTemplate.id,
        requesterSysId: user.UserSysId,
        requesterName: user.UserId,
      });
      onSuccess();
    } catch (error) {
      console.error('보고서 추가 실패:', error);
      alert('보고서 추가에 실패했습니다.');
    }
    finally {
      setIsPending(false);
    }
  };
  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>보고서 추가</h3>
          <div className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
        <div className="side-modal-content">
          <table className='transparent-table w-full'>
            <tr>
              <td>
                <label htmlFor="reportName" className='w-20 mr-10 text-b2-700 required'>보고서명</label>
              </td>
              <td>
                <input type="text" id="reportName" name="reportName" className='w-full input-primary' placeholder='보고서명을 입력해주세요.' onChange={handleChangeInput}/>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="reportTemplate" className='w-20 mr-10 text-b2-700 required'>템플릿</label>
              </td>
              <td>
                <Selector
                id="reportTemplate"
                mode="api"
                apiEndpoint="/doc-management/api/template" 
                dataTransform={transformReportTemplateData} 
                buildApiParams={buildApiParams} 
                apiQueryKeys={getQueryKeys} 
                value={fromData.reportTemplate} 
                onChange={handleChangeSelector}
                placeholder="템플릿을 선택하세요"
                enableSearch={true}
                searchDebounceMs={500}/>
              </td>
            </tr>
          </table>
          <div className="mt-10">
            <button className="btn btn-primary big-btn w-full" onClick={handleCreateReportRequest} disabled={isPending || !fromData.reportName || !fromData.reportTemplate}>{isPending ? '추가중...' : '추가'}</button>
          </div>
          {createReportRequest.error && (
            <div className="mt-10 text-red-500 text-c2-400">
              보고서 추가에 실패했습니다.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ReportAppendModal